// extracted by mini-css-extract-plugin
module.exports = {"outer":"Score_outer_3Dcqd","wrapper":"Score_wrapper_2tI_S","score":"Score_score_3kyrD","text":"Score_text_13_OC"};